"use client";
import BlogCard from "@/common/BlogCard";
import Button from "@/common/Button";
import BlogSkeleton from "@/components/Skeleton/BlogSkeleton";
import { getBlogActiveCards } from "@/services/blogActiveCards";
import { ActiveBlogsData } from "@/types/BlogsType";
import { useMutation } from "@tanstack/react-query";
import Link from "next/link";
import { useCallback, useEffect, useState } from "react";

function Blog() {
  const [activeBlogs, setActiveBlogs] = useState<ActiveBlogsData[]>([]);
  const { mutateAsync: getActiveBlogsCard, isPending } = useMutation({
    mutationFn: getBlogActiveCards,
    retry: 2,
    retryDelay: 1000,
  });
  const getAllActiveBlogs = useCallback(async () => {
    try {
      const response = await getActiveBlogsCard({
        take: 3,
        isActive: true,
        selected: true,
      });
      if (response?.isSuccess) {
        setActiveBlogs(response?.data);
      }
    } catch (err) {
      console.log("error in fetch all data for last offers ", err);
    }
  }, [getActiveBlogsCard]);
  useEffect(() => {
    getAllActiveBlogs();
  }, [getAllActiveBlogs]);

  return (
    <>
      {isPending ? (
        <BlogSkeleton />
      ) : activeBlogs?.length ? (
        <div className="my-5 lg:mt-20  mx-6 lg:mx-16 bg-ws-gray-200 p-8 sm:p-12 rounded-4xl">
          <div className="flex flex-col gap-3">
            <p className="text-ws-gray-400  text-lg sm:text-2xl">
              {activeBlogs[0]?.documentGroupName || "بلاگ"}
            </p>
            <h2 className="text-xl  lg:text-3xl   text-ws-gray-800 font-bold">
              دانش، اطلاعات و ایده‌ها
            </h2>
          </div>
          <div className="flex  flex-col items-center  gap-3">
            <div className="flex  gap-8 md:gap-8 md:flex-row flex-col  xl:gap-16  mt-10 items-start justify-between w-full">
              {activeBlogs?.slice(0, 3)?.map((blog) => (
                <BlogCard key={blog?.id} {...blog} />
              ))}
            </div>

            <Link href="/blogList" className="text-ws-gray-500">
              <Button
                type="button"
                variant="dark-gray"
                className="mt-9 sm:text-lg text-sm  p-3 sm:p-3 text-ws-white-100 px-8 sm:px-10 cursor-pointer corner-radius"
              >
                مطالب بیشتر
              </Button>
            </Link>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Blog;
